import type { SVGProps } from 'react';

const SvgRaRejected = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="m21.46 11.05-1.44-4.32a4 4 0 0 0-3.79-2.74H5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2.67a7.16 7.16 0 0 1 2.88 4.71l.09.59a2.7 2.7 0 0 0 1.29 1.81c.42.24.89.37 1.36.37.29 0 .58-.05.85-.14a2.7 2.7 0 0 0 1.85-2.57v-3.77h2.61c.98 0 1.86-.45 2.43-1.25.57-.79.72-1.78.41-2.7zM5 6h2v6H5zm14.42 6.58c-.19.26-.49.42-.81.42H16c-1.1 0-2 .9-2 2v3.77c0 .3-.19.57-.48.67-.26.09-.48 0-.58-.06s-.28-.2-.33-.43l-.08-.54A9.16 9.16 0 0 0 9 12.48V6h7.22c.86 0 1.62.55 1.9 1.37l1.44 4.32c.1.31.05.64-.14.9z"
    />
  </svg>
);
export default SvgRaRejected;
